module.exports = __webpack_public_path__ + "71ec70c719f49eee9213df10c5fe467e.svg";